/**
 * Shared color definitions used by both tailwind.config.ts and runtime code.
 * Extracted to avoid importing the full tailwind config (which uses require() for plugins)
 * into the browser bundle.
 */
export const customColors = {
  border: {
    DEFAULT: '#E5E6E6',
    highlight: '#00000066',
  },
  background: '#ffffff',
  primary: '#091A59',
  secondary: '#E2E8F0',
  accent: '#f5f5f5',
  base: {
    50: '#f0f4ff',
    100: '#e1e9ff',
    200: '#c3d3ff',
    300: '#a5bdff',
    400: '#87a7ff',
    500: '#0f4fd9',
    600: '#0a32c2',
    700: '#072591',
    800: '#051961',
    900: '#020c30',
  },
  base2: {
    50: '#e7f3fe',
    100: '#d0e8fd',
    200: '#a1d0fb',
    300: '#71b9f9',
    400: '#42a1f7',
    500: '#138af5',
    600: '#0f6ec4',
    700: '#0b5393',
    800: '#083762',
    900: '#041c31',
  },
  ternary: {
    50: '#ece8fe',
    100: '#d8d1fc',
    200: '#b2a3fa',
    300: '#8b74f7',
    400: '#6546f5',
    500: '#3e18f2',
    600: '#3213c2',
    700: '#250e91',
    800: '#190a61',
    900: '#0c0530',
  },
  complement: {
    50: '#fefce9',
    100: '#fdf8d3',
    200: '#fbf1a7',
    300: '#f8ea7a',
    400: '#f6e34e',
    500: '#f4dc22',
    600: '#c3b01b',
    700: '#928414',
    800: '#62580e',
    900: '#312c07',
  },
  complementTernary: {
    50: '#fef5e8',
    100: '#fdebd1',
    200: '#fbd7a3',
    300: '#f9c274',
    400: '#f7ae46',
    500: '#f59a18',
    600: '#c47b13',
    700: '#935c0e',
    800: '#623e0a',
    900: '#311f05',
  },
  typography: {
    white: '#fafafa',
    black: '#0B0B0B',
    grey: '#A1A1A1',
    darkgrey: '#878787',
  },
  success: {
    DEFAULT: '#2EC934',
    50: '#effef5',
    100: '#dafee9',
    200: '#b7fbd5',
    300: '#6bf4a8',
    400: '#41e78c',
    500: '#18cf6a',
    600: '#0dac55',
    700: '#0e8745',
    800: '#116a3a',
    900: '#105732',
    950: '#02311a',
  },
  mid: {
    DEFAULT: '#F8E21C',
    50: '#fcfde9',
    100: '#fbfcc5',
    200: '#fbf88d',
    300: '#f8ec4c',
    400: '#f4dc22',
    500: '#e4c30e',
    600: '#c59809',
    700: '#9d6e0b',
    800: '#825711',
    900: '#6e4715',
    950: '#402508',
  },
  destructive: {
    DEFAULT: '#F81C1C',
    50: '#fef4f2',
    100: '#ffe6e1',
    200: '#ffd1c8',
    300: '#ffb1a2',
    400: '#fd846c',
    500: '#f56043',
    600: '#e24020',
    700: '#be3217',
    800: '#9d2d17',
    900: '#822b1a',
    950: '#471208',
  },
  muted: {
    DEFAULT: '#fafafa',
    highlight: '#f2f2f2',
    foreground: '#737373',
  },
  dashboardblue: {
    DEFAULT: '#0D40F3',
    50: '#E7ECFE',
    100: '#CFD9FD',
    150: '#B6C6FB',
    200: '#9EB3FA',
    300: '#6E8CF8',
    400: '#3D66F5',
    500: '#0D40F3',
    600: '#0A33C2',
    700: '#082692',
    800: '#051A61',
    850: '#041349',
    900: '#030D31',
    950: '#010618',
  },
  warning: {
    DEFAULT: '#FB923C',
    50: '#fef7ed',
    100: '#fdedd3',
    200: '#fbd9a6',
    300: '#f9be6e',
    400: '#f7a344',
    500: '#FB923C',
    600: '#e67e1a',
    700: '#c06314',
    800: '#9a4f17',
    900: '#7c4318',
    950: '#432009',
  },
} as const;
